import React, { useState } from "react";
import ContentContainer from "./contentContainer";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import PageTitle from "./pageTitle";
import { useModelState } from '../../hooks';
import { parameterHelper, apiHostUrl } from "../../helpers";
import { useDealerExistsAnon } from "../../fetch/userFetch";
import Spinner from "../spinner/Spinner";

const defaultState = { accountNumber: '', email: '', feedbackMessage: '', name: '' };
const emailRegEx = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
const defaultParameters = { AccountNumber: '', SnapshotId: null, Feature: null };

export default function VesselInfoFeedback() {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const { AccountNumber: prefilledAccountNumber, SnapshotId: snapshotId, Feature: feature } = parameterHelper.getUrlParameters(defaultParameters);
    const [model, handleValueChanged, setModelState] = useModelState({ ...defaultState, accountNumber: prefilledAccountNumber, snapshotId, feature });

    const { accountNumber, name, email, feedbackMessage } = model;

    const { exists: dealerValidationValue } = useDealerExistsAnon(accountNumber);
    const isValidated = dealerValidationValue != null;
    const isDealerValid = !!dealerValidationValue;

    let isEmailValid = false;
    if (!!email) {
        isEmailValid = email.match(emailRegEx);
    }

    const isValid = (!email || isEmailValid) && !!feedbackMessage && (!accountNumber || isDealerValid) && !saving;

    const handleSubmitClick = () => {
        setSaving(true);

        fetch(`${apiHostUrl}/api/v1/g3/feedback/vesselInfo`,
            {
                method: 'POST',
                body: JSON.stringify(model),
                headers: { 'Content-Type': 'application/json' }
            })
            .then((response) => {
                if (!response.ok) {
                    console.log(response);
                    setError('Error submitting contact');
                } else {
                    setModelState(defaultState);
                    window.location.replace('/')
                }
            }, (error) => {
                setError('Error submitting contact');
            }).finally(() => {
                setSaving(false);
            });
    }

    return (
        <ContentContainer>
            <PageTitle title='Vessel Info Feedback' />

            <Dialog
                open={!!error}
                onClick={() => setError(null)}
            >
                <DialogTitle>Error</DialogTitle>
                <DialogContent>{error}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setError(null)}>Ok</Button>
                </DialogActions>
            </Dialog>

            <Box component="main" sx={{ p: 3, width: '100%' }}>
                {saving ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Spinner />
                        </Grid>
                    </Grid>
                ) : null}
                {!saving ? (
                    <Grid container padding={2}>
                        <Grid item md={6} p={1}>
                            <TextField
                                label="Name"
                                value={name || ''}
                                fullWidth
                                onChange={(event) => handleValueChanged('name', event.target.value)}
                            />
                        </Grid>
                        <Grid item md={6} p={1}>
                            <TextField
                                label="Email"
                                error={!!email && !isEmailValid}
                                value={email || ''}
                                fullWidth
                                onChange={(event) => handleValueChanged('email', event.target.value)}
                            />
                        </Grid>
                        <Grid item md={6} p={1}>
                            <TextField
                                label="Account Number"
                                error={!!accountNumber && !isDealerValid && isValidated}
                                value={accountNumber || ''}
                                fullWidth
                                onChange={(event) => handleValueChanged('accountNumber', event.target.value)}
                            />
                        </Grid>
                        <Grid item md={12} p={1}>
                            <TextField
                                label="Feedback"
                                value={feedbackMessage || ''}
                                fullWidth
                                onChange={(event) => handleValueChanged('feedbackMessage', event.target.value)}
                                multiline
                                rows={6}
                            />
                        </Grid>
                        <Grid item md={12} p={1}>
                            <Button
                                disabled={!isValid}
                                onClick={handleSubmitClick}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                ) : null}
            </Box>
        </ContentContainer>
    );
}